import React from 'react';
import { connect } from 'react-redux';

import {
    requestHarvestEventDocumentsLoad,
    harvestEventDocumentsLoadCanceled
} from 'services/harvestEventDocuments/actions';

interface OwnProps {
    entityId?: number;
}

interface DispatchProps {
    loadHarvestEventDocuments: typeof requestHarvestEventDocumentsLoad;
    cancelLoadHarvestEventDocuments: typeof harvestEventDocumentsLoadCanceled;
}

type Props = OwnProps & DispatchProps;

export class HarvestEventDocumentsRequestComponent extends React.PureComponent<
    Props
> {
    componentDidMount(): void {
        const { entityId, loadHarvestEventDocuments } = this.props;

        if (entityId) {
            loadHarvestEventDocuments(entityId);
        }
    }

    componentDidUpdate(prevProps: Props): void {
        const { entityId, loadHarvestEventDocuments } = this.props;

        if (entityId && prevProps.entityId !== entityId) {
            loadHarvestEventDocuments(entityId);
        }
    }

    componentWillUnmount(): void {
        const { cancelLoadHarvestEventDocuments } = this.props;

        cancelLoadHarvestEventDocuments();
    }

    render(): null {
        return null;
    }
}

export default connect(
    null,
    {
        loadHarvestEventDocuments: requestHarvestEventDocumentsLoad,
        cancelLoadHarvestEventDocuments: harvestEventDocumentsLoadCanceled
    }
)(HarvestEventDocumentsRequestComponent);
